var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,13.5v1c0,.28-.22,.5-.5,.5s-.5-.22-.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h1c.83,0,1.5,.67,1.5,1.5Zm-9.5-1.5h-1c-.83,0-1.5,.67-1.5,1.5v1c0,.28,.22,.5,.5,.5s.5-.22,.5-.5v-1c0-.28,.22-.5,.5-.5h1c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5Zm0,7h-1c-.28,0-.5-.22-.5-.5v-1c0-.28-.22-.5-.5-.5s-.5,.22-.5,.5v1c0,.83,.67,1.5,1.5,1.5h1c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5Zm9-2c-.28,0-.5,.22-.5,.5v1c0,.28-.22,.5-.5,.5h-1c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h1c.83,0,1.5-.67,1.5-1.5v-1c0-.28-.22-.5-.5-.5Zm-7-9H6.5c-.28,0-.5,.22-.5,.5s.22,.5,.5,.5h4c.28,0,.5-.22,.5-.5s-.22-.5-.5-.5Zm11.5,1.99v9.51c0,2.48-2.02,4.5-4.5,4.5H6.5c-2.48,0-4.5-2.02-4.5-4.5V4.5C2,2.02,4.02,0,6.5,0h5.51c1.74,0,3.37,.68,4.6,1.9l3.48,3.48c1.23,1.23,1.9,2.86,1.9,4.6ZM15.9,2.61c-.55-.55-1.2-.97-1.9-1.24V6.5c0,.83,.67,1.5,1.5,1.5h5.13c-.27-.71-.69-1.35-1.24-1.9l-3.48-3.48Zm5.1,7.37c0-.33-.03-.66-.09-.99h-5.41c-1.38,0-2.5-1.12-2.5-2.5V1.09c-.32-.06-.65-.09-.99-.09H6.5c-1.93,0-3.5,1.57-3.5,3.5v15c0,1.93,1.57,3.5,3.5,3.5h11c1.93,0,3.5-1.57,3.5-3.5V9.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateAlt);
export default __webpack_public_path__ + "static/media/template-alt.4265cbd0c04c88ddf9ce7e91f61e7302.svg";
export { ForwardRef as ReactComponent };